export const ELEMENT_LENGTH_FOR_DESKTOP = 0.84;
export const ELEMENT_LENGTH_FOR_MOBILE = 1.74;
export const ADDITIONAL_SPACE = 0.5;

